import {
    CREATE_TB,
    FETCH_SEARCHED_TB_SAMPLE_LIST,
    FETCH_TB_APPROVED_SAMPLE,
    FETCH_TB_APPROVED_SAMPLE_ENTERED_RESULT,
    FETCH_TB_COLLECTED_SAMPLE,
    FETCH_TB_ORDERED_SAMPLE,
    FETCH_TB_SAMPLE,
    FETCH_TB_SAMPLES
} from "constants/ActionTypes";

const INITIAL_STATE = {
  data: [],
  loading: false,
  tbSampleList: [],
  tbOrderedSampleList: [],
  tbCollectedSampleList: [],
  tbApprovedSampleList: [],
  tbApprovedSampleEnterResultList: [],
  tbSearchedTBSampleList: [],
  tbSample: null,
};

const TBReducer = (state= INITIAL_STATE, action) => {
  switch (action.type) {
    case CREATE_TB: {
      let updatedList = state.tbSampleList;
      updatedList = [action.payload, ...updatedList];

      return {
        ...state,
        tbSampleList: updatedList,
      };
    }
    case FETCH_TB_SAMPLES: {
      return {
        ...state,
        tbSampleList: action.payload,
      };
    }
    case FETCH_TB_APPROVED_SAMPLE: {
      return {
        ...state,
        tbApprovedSampleList: action.payload,
      };
    }
    case FETCH_TB_COLLECTED_SAMPLE: {
      return {
        ...state,
        tbCollectedSampleList: action.payload,
      };
    }
    case FETCH_TB_ORDERED_SAMPLE: {
      return {
        ...state,
        tbOrderedSampleList: action.payload,
      };
    }
    case FETCH_SEARCHED_TB_SAMPLE_LIST: {
      return {
        ...state,
        tbSearchedTBSampleList: action.payload,
      };
    }
    case FETCH_TB_SAMPLE: {
      return {
        ...state,
        tbSample: action.payload,
      };
    }
    case FETCH_TB_APPROVED_SAMPLE_ENTERED_RESULT: {
      return {
        ...state,
        tbApprovedSampleEnterResultList: action.payload,
      };
    }
    default:
      return state;
  }
}

export default TBReducer
